import type { IconSvgObject } from './types';

const MoveUpLeftIcon: IconSvgObject = [
  ["path", { d: "M5.40629 12C5.38762 10.6865 4.48396 6.33638 5.4063 5.41409C6.32862 4.4918 10.6787 5.39542 11.9922 5.41408", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19.5225 18.4697C19.8154 18.7626 19.8154 19.2374 19.5225 19.5303C19.2296 19.8232 18.7548 19.8232 18.4619 19.5303L18.9922 19L19.5225 18.4697ZM5.46186 6.53033C5.16896 6.23744 5.16896 5.76256 5.46186 5.46967C5.75475 5.17678 6.22962 5.17678 6.52252 5.46967L5.99219 6L5.46186 6.53033ZM18.9922 19L18.4619 19.5303L5.46186 6.53033L5.99219 6L6.52252 5.46967L19.5225 18.4697L18.9922 19Z", fill: "currentColor", key: "1" }]
];

export default MoveUpLeftIcon;
